import { BaseBlock } from '@components/base-block'
import { LabelS } from '@components/base-typography'
import { Icon } from '@components/icon'
import { UserRole } from '@lib/graphql/documents.generated'
import { AdminRoutes, Routes } from '@lib/routes'
import { useLogout } from '@modules/auth/hooks/use-logout'
import { useMe } from '@modules/users/hooks/use-me'
import { boxShadow } from '@styles/box-shadow'
import { colors } from '@styles/colors'
import { transition } from '@styles/utils'
import { Drawer } from 'baseui/drawer'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { padding } from 'polished'
import { useState } from 'react'
import { useStyletron } from 'styletron-react'

export const BaseDrawer = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [css] = useStyletron()
  const router = useRouter()
  const { logout } = useLogout()

  const { me } = useMe()

  const menuItemStyle = css({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    ...transition('background-color', '0.2s'),
    ...padding('16px', '16px'),
    ':hover': {
      backgroundColor: colors.gray50,
    },
  })

  return (
    <>
      <BaseBlock
        flexbox
        flexCenter
        display={['block', 'block', 'none', 'none']}
        onClick={() => setIsOpen((prev) => !prev)}
        cursor="pointer"
        rounded={8}
        className={css({
          ...padding('4px'),
          ':hover': {
            backgroundColor: colors.gray50,
          },
        })}
      >
        <Icon type="Navigation" />
      </BaseBlock>
      <Drawer
        autoFocus={false}
        renderAll
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        overrides={{
          Root: {
            style: {
              zIndex: 9999,
            },
          },
        }}
      >
        <BaseBlock>
          <ul
            className={css({
              overflow: 'hidden',
            })}
          >
            <li
              className={css({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                rowGap: '8px',
                ...padding('20px', '16px'),
                ...boxShadow('borderBottom'),
              })}
            >
              <LabelS>{me?.nickname}님</LabelS>
              <LabelS color={colors.gray400}>{me?.email}</LabelS>
            </li>
            {me?.role === UserRole.Admin && (
              <>
                <li onClick={() => setIsOpen(false)}>
                  {router.pathname.includes('admin') ? (
                    <Link href={Routes.HOME}>
                      <a className={menuItemStyle}>
                        <LabelS flex="1 1 auto" color={colors.gray600}>
                          온톨로 이동하기
                        </LabelS>
                        <Icon type="ChevronRight" size={12} />
                      </a>
                    </Link>
                  ) : (
                    <Link href={AdminRoutes.HOME}>
                      <a className={menuItemStyle}>
                        <LabelS flex="1 1 auto" color={colors.gray600}>
                          관리자 페이지
                        </LabelS>
                        <Icon type="ChevronRight" size={12} />
                      </a>
                    </Link>
                  )}
                </li>
              </>
            )}
            {[
              {
                name: '홈',
                icon: undefined,
                onClick: undefined,
                color: undefined,
                href: Routes.HOME,
              },
              ...((me?.professionalId && [
                {
                  name: '해석 참여',
                  href: Routes.DOCTOR_EXAMINATIONS,
                },
                {
                  name: '나의 해석',
                  href: Routes.DOCTOR_INTERPRETATIONS,
                },
                {
                  name: '정산 관리',
                  href: Routes.DOCTOR_EARNINGS,
                },
                {
                  name: '내 정보',
                  href: Routes.DOCTOR_PROFILE,
                },
              ]) ||
                []),
              {
                name: '내 검사 결과',
                icon: undefined,
                onClick: undefined,
                color: undefined,
                href: Routes.PATIENT_EXAMINATIONS,
              },
              {
                name: '해석 요청',
                icon: undefined,
                onClick: undefined,
                color: undefined,
                href: Routes.UPLOAD,
              },
              {
                name: '계정 설정',
                icon: undefined,
                onClick: undefined,
                color: undefined,
                href: Routes.SETTINGS_ACCOUNT,
              },
              {
                name: '알림 설정',
                icon: undefined,
                onClick: undefined,
                color: undefined,
                href: Routes.SETTINGS_NOTIFICATIONS,
              },
              {
                name: '문의 내역',
                icon: undefined,
                onClick: undefined,
                color: undefined,
                href: Routes.SETTINGS_INQUIRIES,
              },
            ].map(({ name, icon, href, onClick, color = colors.gray700 }) => (
              <li key={name} onClick={() => setIsOpen(false)}>
                {href && (
                  <Link href={href}>
                    <a className={menuItemStyle}>
                      {icon && <Icon type={icon} size={20} color={color} />}
                      <LabelS flex="1 1 auto" color={color}>
                        {name}
                      </LabelS>
                      {icon && <Icon type="ChevronRight" size={12} />}
                    </a>
                  </Link>
                )}
                {Boolean(onClick) && (
                  <div className={menuItemStyle} onClick={onClick}>
                    {icon && <Icon type={icon} size={20} color={color} />}
                    <LabelS flex="1 1 auto" color={color}>
                      {name}
                    </LabelS>
                    {icon && <Icon type="ChevronRight" size={12} />}
                  </div>
                )}
              </li>
            ))}
            <li>
              <div className={menuItemStyle} onClick={logout}>
                <LabelS flex="1 1 auto">로그아웃</LabelS>
              </div>
            </li>
          </ul>
        </BaseBlock>
      </Drawer>
    </>
  )
}
